import { jsxs as g, jsx as e } from "react/jsx-runtime";
import { Checkbox as C, ActionMenu as N } from "@systemeio/ui";
import m from "react";
import { FilePreview as w } from "../file-preview/index.mjs";
import { twMerge as c } from "tailwind-merge";
function B({
  fileType: p,
  src: u,
  alt: f,
  name: o,
  secondaryText: i,
  style: d,
  selected: s,
  actionMenu: t,
  className: x,
  imageWidth: h,
  imageHeight: v,
  onSelect: b
}) {
  const r = m.useRef(null), a = m.useRef(null);
  return /* @__PURE__ */ g(
    "div",
    {
      className: c("relative flex cursor-pointer flex-col", x),
      style: d,
      onClick: (l) => {
        var n;
        r.current && !((n = a.current) != null && n.contains(l.target)) && r.current.click();
      },
      children: [
        /* @__PURE__ */ e(
          w,
          {
            src: u ?? "",
            fileType: p,
            alt: f,
            width: h,
            height: v,
            className: c(
              "relative -top-[2px] -left-[2px] box-content flex-1 rounded-lg border-2 border-transparent",
              s && "border-brand-primary"
            ),
            isThumbnail: !0
          }
        ),
        /* @__PURE__ */ e("div", { ref: a, className: "absolute top-1 left-1", children: /* @__PURE__ */ e(C, { inputRef: r, value: s, onChange: b }) }),
        /* @__PURE__ */ e("div", { onClick: (l) => l.stopPropagation(), children: /* @__PURE__ */ e(
          N,
          {
            toggleOnHover: !0,
            menuButtonClassName: "absolute top-1 right-1 p-1 h-[20px] w-[26px]",
            menuItemsClassName: "z-30",
            ...t,
            menuItems: (t == null ? void 0 : t.menuItems) ?? []
          }
        ) }),
        /* @__PURE__ */ e("div", { className: "text-text-primary mt-1 overflow-clip truncate text-base", title: o, children: o }),
        /* @__PURE__ */ e(
          "div",
          {
            className: "text-text-secondary mt-1 overflow-clip truncate text-sm",
            title: i,
            children: i
          }
        )
      ]
    }
  );
}
export {
  B as FileCard
};
